<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol><h5 class="my-3">Client Management</h5> </CCol>
                        <CCol>
                            <CButton
                                color="primary"
                                class="m-2 float-right"
                                @click="
                                    addClientModal = true;
                                    isEmailExist = false;
                                    isClientNameExist = false;
                                    reset();
                                "
                                >Add Client
                            </CButton>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody :style="{ position: 'relative', top: '-18px' }">
                    <CDataTable
                        v-if="renderActions"
                        :items="clients"
                        :fields="fields"
                        :column-filter="false"
                        :itemsPerPageSelect="false"
                        hover
                        sorter
                        pagination
                        @filtered-items-change="setCurrentItems"
                        :tableFilter="{
                            label: ' ',
                            placeholder: 'Search',
                        }"
                    >
                        <template #user_count="{ item }">
                            <td class="py-auto">
                                <CBadge
                                    color="primary"
                                    class="font-weight-bold"
                                    shape="pill"
                                    style="font-size: 90%"
                                >
                                    {{ getUserCount(item) }}
                                </CBadge>
                            </td>
                        </template>
                        <template #users="{ item }">
                            <td class="py-1">
                                <CButton
                                    color="secondary"
                                    size="sm"
                                    class="m-1"
                                    v-c-tooltip="{
                                        content: 'Users',
                                        placement: 'bottom',
                                    }"
                                    @click="getClientUsers(item)"
                                >
                                    Users
                                </CButton>
                            </td>
                        </template>
                        <template #status="{ item }">
                            <td
                                class="py-auto font-weight-bold"
                                :style="
                                    getClientStatus(item) === 'Active'
                                        ? 'color: #0bbd40'
                                        : 'color: #ff6700'
                                "
                            >
                                {{ getClientStatus(item) }}
                            </td>
                        </template>
                        <template #description="{ item }">
                            <td>
                                <CLink
                                    @click="
                                        viewDescriptionModal = true;
                                        description = item.description;
                                    "
                                    >View</CLink
                                >
                            </td>
                        </template>
                        <template #action="{ item }">
                            <!-- Action buttons -->
                            <td class="py-1">
                                <template v-if="renderActions">
                                    <!-- Edit -->
                                    <CButton
                                        color="success"
                                        square
                                        size="sm"
                                        class="m-1"
                                        v-c-tooltip="{
                                            content: 'Edit',
                                            placement: 'bottom',
                                        }"
                                        @click="
                                            addClientModal = true;
                                            edit = true;
                                            clientDetails = { ...item };
                                            clientAdminDetails = {
                                                ...item.users[0],
                                            };
                                            backupDetails = { ...item };
                                        "
                                    >
                                        <CIcon name="cil-pencil" />
                                    </CButton>

                                    <!-- Enable -->
                                    <CButton
                                        v-if="
                                            getClientStatus(item) === 'Inactive'
                                        "
                                        color="info"
                                        square
                                        size="sm"
                                        class="m-1"
                                        v-c-tooltip="{
                                            content: 'Activate',
                                            placement: 'bottom',
                                        }"
                                        @click="
                                            clientDetails = { ...item };
                                            confirm.enable = true;
                                            confirm.type = 'activate';
                                        "
                                    >
                                        <CIcon name="cil-file" />
                                    </CButton>

                                    <!-- Disable -->
                                    <CButton
                                        v-if="
                                            getClientStatus(item) === 'Active'
                                        "
                                        color="warning"
                                        square
                                        size="sm"
                                        class="m-1"
                                        v-c-tooltip="{
                                            content: 'Deactivate',
                                            placement: 'bottom',
                                        }"
                                        @click="
                                            clientDetails = { ...item };
                                            confirm.enable = true;
                                            confirm.type = 'deactivate';
                                        "
                                    >
                                        <CIcon name="cil-file" />
                                    </CButton>
                                </template>
                            </td>
                            <!--  -->
                        </template>
                    </CDataTable>
                </CCardBody>
            </CCard>
        </CCol>

        <CModal
            :title="edit ? 'Update Client' : 'Add Client'"
            :show.sync="addClientModal"
            fade
            class="disable-footer"
            centered
            :closeOnBackdrop="false"
        >
            <CForm>
                <CInput
                    type="text"
                    label="Name"
                    :value.sync="$v.clientDetails.name.$model"
                    :isValid="checkIfValid('name')"
                    placeholder="Enter a client name"
                    :invalidFeedback="
                        isClientNameExist
                            ? 'Client name already exist'
                            : 'Enter a valid client name between 3 and 50 characters. Numbers and special characters not allowed'
                    "
                    @input="isClientNameExist = false"
                />
                <CInput
                    label="Primary Contact Name"
                    :value.sync="$v.clientAdminDetails.name.$model"
                    :isValid="checkIfValidUser('name')"
                    placeholder="Enter the primary contact name"
                    :invalidFeedback="`Enter a valid user name between 3 and 50 characters. \nNumbers and special characters not allowed`"
                />
                <CInput
                    label="Email"
                    :value.sync="$v.clientAdminDetails.email.$model"
                    :isValid="checkIfValidUser('email')"
                    placeholder="Enter the primary contact email"
                    :invalidFeedback="
                        isEmailExist
                            ? 'Email already exist'
                            : 'Enter a valid email. Max 50 characters'
                    "
                    @input="isEmailExist = false"
                />
                <CTextarea
                    label="Description"
                    :value.sync="$v.clientDetails.description.$model"
                    :isValid="checkIfValid('description')"
                    placeholder="Enter a description for client"
                    invalidFeedback="Enter a valid description. Min 6 characters"
                />
            </CForm>
            <div class="inactive-modal-response mt-4 float-right">
                <CButton
                    type="cancel"
                    color="secondary"
                    class="m-1"
                    @click="
                        addClientModal = false;
                        reset();
                    "
                >
                    Cancel
                </CButton>
                <CButton
                    type="submit"
                    color="primary"
                    class="m-1"
                    @click="edit ? handleUpdateClient() : handleAddClient()"
                >
                    Submit
                </CButton>
            </div>
        </CModal>

        <Confirm
            :handleOperation="handleChangeClientStatus"
            :modal="confirm.enable"
            :type="confirm.type"
            @close="confirm.enable = false"
        />

        <CModal
            title="Description"
            :show.sync="viewDescriptionModal"
            class="disable-footer"
            centered
            fade
            :closeOnBackdrop="false"
        >
            <div
                style="
                    max-height: 650px;
                    white-space: pre-wrap;
                    overflow-y: scroll;
                "
                class="pr-2"
            >
                <p>{{ description }}</p>
            </div>
        </CModal>

        <CElementCover v-if="spinner" :opacity="0.8" />
    </CRow>
</template>

<script>
import _ from "../../utility/utility";
import queries from "./queries";
// Validation
import { validationMixin } from "vuelidate";
import {
    required,
    minLength,
    maxLength,
    helpers,
    email,
} from "vuelidate/lib/validators";

const fields = [
    { key: "name", label: "Client Name" },
    { key: "description" },
    { key: "user_count" },
    { key: "status" },
    { key: "users", _classes: "remove-sort-arrow" },
    { key: "action", _classes: "remove-sort-arrow", _style: "width: 7rem" },
];

export default {
    data() {
        return {
            currentItems: [],
            clients: [],
            fields,
            addClientModal: false,
            clientDetails: this.getEmptyFormForClient(),
            clientAdminDetails: this.getEmptyFromForClientAdmin(),
            backupDetails: {},
            edit: false,
            renderActions: true,
            confirm: { enable: false, type: "" },
            isEmailExist: false,
            isClientNameExist: false,
            viewDescriptionModal: false,
            description: "",
            spinner: false,
        };
    },
    mixins: [validationMixin],
    methods: {
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (/^[A-Za-z]+$/.test(char)) return true;
            // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
        },
        getEmptyFormForClient: () => ({
            name: "",
            description: "",
        }),
        getEmptyFromForClientAdmin: () => ({
            name: "",
            email: "",
        }),
        getUserCount(client) {
            return client.users.length || 0;
        },
        getClientStatus(client) {
            return client.users.filter((user) => user.account_disabled === true)
                .length === client.users.length
                ? "Inactive"
                : "Active";
        },
        checkIfValid(fieldName) {
            let field = this.$v.clientDetails[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },
        checkIfValidUser(fieldName) {
            let field = this.$v.clientAdminDetails[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },
        reset() {
            this.$v.$reset();
            this.clientDetails = this.getEmptyFormForClient();
            this.clientAdminDetails = this.getEmptyFromForClientAdmin();
            this.confirm.enable = false;
            this.edit = false;
        },
        setCurrentItems(val) {
            this.currentItems = val;
        },
        getClientUsers(client) {
            this.$router.push({
                name: "ClientUsers",
                query: {
                    client_id: client.id,
                },
            });
        },
        async handleAddClient() {
            try {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    const res = await this.$apollo.mutate({
                        mutation: queries.INSERT_CLIENT,
                        variables: {
                            name: this.clientDetails.name,
                            description: this.clientDetails.description,
                            userName: this.clientAdminDetails.name,
                            userEmail:
                                this.clientAdminDetails.email.toLowerCase(),
                            added: _.getCurrentTimeStamp(),
                            updated: _.getCurrentTimeStamp(),
                        },
                    });
                    const result = res.data.insert_spendmd_db_clients.returning;
                    if (result[0].id) {
                        this.$apollo.queries.userData.refetch();
                        this.reset();
                        this.addClientModal = false;
                    }
                }
            } catch (err) {
                if (
                    err.message.includes(
                        'duplicate key value violates unique constraint "users_email_key"'
                    )
                ) {
                    this.isEmailExist = true;
                    this.$v.clientAdminDetails.email.$touch();
                }
                if (
                    err.message.includes(
                        'duplicate key value violates unique constraint "clients_name_key"'
                    )
                ) {
                    this.isClientNameExist = true;
                    this.$v.clientAdminDetails.email.$touch();
                }
            }
        },
        async handleUpdateClient() {
            try {
                this.$v.clientDetails.$touch();
                if (!this.$v.clientDetails.$invalid) {
                    const res = await this.$apollo.mutate({
                        mutation: queries.UPDATE_CLIENT,
                        variables: {
                            client_id: this.clientDetails.id,
                            description: this.clientDetails.description,
                            client_name: this.clientDetails.name,
                            userName: this.clientAdminDetails.name,
                            userEmail:
                                this.clientAdminDetails.email.toLowerCase(),
                            updated: _.getCurrentTimeStamp(),
                            user_id: this.clientAdminDetails.id,
                        },
                    });
                    const result = res.data.update_spendmd_db_clients.returning;
                    if (result[0].id) {
                        this.$apollo.queries.userData.refetch();
                        this.reset();
                        this.addClientModal = false;
                    }
                }
            } catch (err) {
                if (
                    err.message.includes(
                        'duplicate key value violates unique constraint "users_email_key"'
                    )
                ) {
                    this.isEmailExist = true;
                    this.$v.clientAdminDetails.email.$touch();
                }
                if (
                    err.message.includes(
                        'duplicate key value violates unique constraint "clients_name_key"'
                    )
                ) {
                    this.isClientNameExist = true;
                    this.$v.clientAdminDetails.email.$touch();
                }
            }
        },
        async handleChangeClientStatus() {
            try {
                const res = await this.$apollo.mutate({
                    mutation: queries.CHANGE_CLIENT_STATUS,
                    variables: {
                        client_id: this.clientDetails.id,
                        account_disabled:
                            this.confirm.type === "deactivate" ? true : false,
                        updated: _.getCurrentTimeStamp(),
                    },
                });
                const result = res.data.update_spendmd_db_users.returning;
                if (result[0].id) {
                    this.reset();
                    this.confirm.enable = false;
                    this.renderActions = false;
                    this.$apollo.queries.userData.refetch();
                    setTimeout(() => {
                        this.renderActions = true;
                    }, 800);
                }
            } catch (err) {
                console.log(err);
            }
        },
    },
    apollo: {
        userData: {
            query: queries.GET_CLIENTS,
            update: (data) => data,
            result({ data }) {
                this.spinner = true;
                this.clients = data.spendmd_db_clients.filter(
                    (el) => el.name !== "SpendMD"
                );
                this.spinner = false;
            },
        },
    },
    validations: {
        clientDetails: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(50),
                isValid: helpers.regex(
                    "isAddress1Valid",
                    /^[A-Za-z-_]+(?: +[A-Za-z-_]+)*$/i
                ),
                isClientNameExist() {
                    if (
                        this.backupDetails.name !== this.clientDetails.name &&
                        this.clients.filter(
                            (el) =>
                                el.name.toLowerCase() ===
                                this.clientDetails.name.toLowerCase()
                        ).length > 0
                    ) {
                        this.isClientNameExist = true;
                    } else {
                        this.isClientNameExist = false;
                    }

                    if (this.isClientNameExist) return false;
                    return true;
                },
            },
            description: {
                required,
                minLength: minLength(6),
                isValid() {
                    if (
                        this.clientDetails.description[0] === " " ||
                        this.clientDetails.description[
                            this.clientDetails.description.length - 1
                        ] === " "
                    )
                        return false;
                    return true;
                },
            },
        },
        clientAdminDetails: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(50),
                isValid: helpers.regex(
                    "isAddress1Valid",
                    /^[A-Za-z-_]+(?: +[A-Za-z-_]+)*$/i
                ),
            },
            email: {
                required,
                email,
                maxLength: maxLength(50),
                isEmailExist() {
                    this.isEmailExist = false;
                    for (const c of this.clients) {
                        if (
                            this.backupDetails.email !==
                                this.clientAdminDetails.email &&
                            c.users.filter(
                                (el) =>
                                    el.email.toLowerCase() ===
                                    this.clientAdminDetails.email.toLowerCase()
                            ).length > 0
                        ) {
                            this.isEmailExist = true;
                            break;
                        }
                    }

                    if (this.isEmailExist) return false;
                    return true;
                },
            },
        },
    },
};
</script>

<style scoped>
textarea.form-control {
    height: 112px !important;
}
</style>
